module.exports = __webpack_public_path__ + "static/media/credit_proposal.a5ad6604.svg";